export default "__VITE_ASSET__ChwxLhvs__"